<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-退货地址列表-添加
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px" v-if="!loading">
      <!--新增退货地址-->
      <div class="common-form">编辑合作渠道</div>
      <el-form-item label="选择API" prop="type_data_id" :rules="[{required: true,message: ' '}]">
        <el-button type="info" size="small" icon="el-icon-plus" @click="changeApiChannel" v-auth="'/plus/points/product/add'">选择API</el-button>
      </el-form-item>
      <el-form-item label="名称" prop="name" :rules="[{required: true,message: ' '}]">
        <el-input type="text" v-model="form.name" class="max-w460" prop="name" disabled></el-input>
        <div class="tips">选择后显示</div>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">上架</el-radio>
          <el-radio :label="2">下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark" :rules="[{required: true,message: ' '}]">
        <el-input type="text" v-model="form.remark" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>
      <el-form-item label="链接" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.setting.h5_wxapp_url"  class="max-w460" placeholder="请输入跳转链接" ></el-input>
      </el-form-item>
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit()" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--api选择-->
    <ApiChannel :isApi="isApi" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeApiFunc"></ApiChannel>
  </div>

</template>

<script>
import PointChannelApi from '@/api/pointchannel.js';
import ApiChannel from '@/components/api/App.vue';
export default {
  components: {
    /*选择商品*/
    ApiChannel
  },
  data() {
    return {
      loading: true,
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        kmd_label_id:0,
        status:10,
        name: '',
        remark: '',
        sort: 1,
        setting:{
          h5_wxapp_url:''
        },
        type_data_id:0,
      },
      /*是否打开选择api*/
      isApi: false,
      /*已有的id*/
      exclude_ids: []

    };
  },
  created() {
    this.form.kmd_label_id = this.$route.query.kmd_label_id;
    /*获取列表*/
    this.getData();
  },

  methods: {
    getData(){
      let self = this;
      PointChannelApi.getPointChannel(
        {
          kmd_label_id: self.form.kmd_label_id
        }
      ).then(function (res) {
        self.exclude_ids=res.data.exclude_ids;
        self.loading=false;
        self.form.status=res.data.model.status;
        self.form.name=res.data.model.name;
        self.form.remark=res.data.model.remark;
        self.form.sort=res.data.model.sort;
        self.form.setting=JSON.parse(res.data.model.setting);
        self.form.type_data_id=res.data.model.type_data_id;
      }).catch(error => {
        self.loading = false;
      });
    },
    /*打开添加*/
    changeApiChannel(list) {
      this.isApi = true;
    },

    /*关闭Api选择*/
    closeApiFunc(e) {
      this.isApi = false;
      this.form.type_data_id=e.params.api_id;
      this.form.name=e.params.name
    },
    //提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          PointChannelApi.editPointChannel(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/plus/points/index?type=channel');

            })
            .catch(error => {
              self.loading = false;
            });
        }
      });


    },

  }

};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/points/channel/edit.vue